import { LeftCircleFilled, RightCircleFilled } from '@ant-design/icons';
import { DatePicker, message } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { FC, ReactNode, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LayoutSite } from '../components/layout';
import { useLocalStorage } from '../localstorage';
import { findapiserverurl, getrace, getraces } from '../services/api.service';
import { getToken } from '../services/auth.header';
import { formatdateYYYYMMDD } from '../types';
import './home.scss';

/* -------------------------------------------------------------------------------- *\
|                               HomePage
\* -------------------------------------------------------------------------------- */
export const HomePage: FC<{ children?: ReactNode }> = ({ children }) =>
{
    const [lastselecteddate, setlastselecteddate] = useLocalStorage('lastselecteddate', formatdateYYYYMMDD(new Date()));
    const [daypicker, setDaypicker] = useState<Dayjs>(dayjs(lastselecteddate));

    const [currentday, setCurrentDay] = useState<string>(lastselecteddate);
    const [sics, setSics] = useState<string[]>([]);
    const [currentsic, setCurrentSic] = useState<string>('');
    const [races, setRaces] = useState<string[]>([]);
    const [currentrace, setCurrentRace] = useState<string>('');
    const [stats, setStats] = useState<string[]>([]);
    const [currentstats, setCurrentStats] = useState<string>('');

    const navigate = useNavigate();

    /* -------------------------------------------------------------------------------- *\
    |                               getRaces
    \* -------------------------------------------------------------------------------- */
    const getRaces = async (day: string) =>
    {
        if (!day)
        {
            setRaces([]);
            return;
        }
        getraces(day)
            .then((datas: string[]) =>
            {
                var scs: string[] = datas.map(d => 
                {
                    var arr: string[] = d.match(/^([0-9]{8})([A-Z-]{2,3})([0-9]{1,})$/) || ["", "", "", ""];
                    return arr[2];
                });
                var s = new Set<string>(scs);
                setSics(Array.from(s));
                setRaces(datas);
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               getRace
    \* -------------------------------------------------------------------------------- */
    const getRace = async (race: string) =>
    {
        if (!race)
        {
            setStats([]);
            return;
        }
        getrace(race)
            .then((datas: string[]) =>
            {
                setStats(datas);
            })
            .catch(error =>
            {
                message.error(error.message);
                if (error.status === 403 || error.status === 401) navigate('/login');
            });
    }
    /* -------------------------------------------------------------------------------- *\
    |                               changeCurrentDate
    \* -------------------------------------------------------------------------------- */
    const changeCurrentDate = (date: string) =>
    {
        setDaypicker(dayjs(date));
        setlastselecteddate(date);
        setCurrentDay(date);
        setCurrentSic('');
        setCurrentRace('');
        getRaces(date);
    }
    /* -------------------------------------------------------------------------------- *\
    |                               datepicker_handler
    \* -------------------------------------------------------------------------------- */
    function datepicker_handler(date: any)
    {
        changeCurrentDate(date.format('YYYYMMDD'));
    }
    /* -------------------------------------------------------------------------------- *\
    |                               effects
    \* -------------------------------------------------------------------------------- */
    useEffect(() =>
    {
        changeCurrentDate(currentday);
    // eslint-disable-next-line
    }, []);
    
    return (
        <LayoutSite>
            <div className="home">
                <div className="home__header">
                    <div></div>
                    <div className='calendar__header__clock'></div>
                </div>
                <div className="home__body">
                    <div className="home__body__title"><em>McLloyd</em> Live Odds</div>
                    <div className='home__body__calendar'>
                        <div className='home__body__calendar__label'>Choix du jour :</div>
                        <LeftCircleFilled className='home__body__calendar__arrow' onClick={() => changeCurrentDate(dayjs(currentday).subtract(1, 'day').format('YYYYMMDD'))} />
                        <DatePicker defaultValue={dayjs(currentday)} value={daypicker} onChange={datepicker_handler} format={'DD/MM/YYYY'} />
                        <RightCircleFilled className='home__body__calendar__arrow' onClick={() => changeCurrentDate(dayjs(currentday).add(1, 'day').format('YYYYMMDD'))}/>
                    </div>
                    {/* <div className='home__body__subtitle'>Days with races :</div>
                    <div className='home__body__days'>
                        {
                            days.map((d, i) =>
                            {
                                return (<div key={'day_' + i} className='home__body__day' onClick={() => { setCurrentDay(d); setCurrentSic(''); setCurrentRace(''); getRaces(d); }}>{d}</div>);
                            })
                        }
                    </div> */}
                    {
                        currentday &&
                        (
                            <>
                                <div className='home__body__subtitle'>{'Tracks of ' + currentday + ':'}</div>
                                <div className='home__body__days'>
                                    {
                                        sics.map((d, i) =>
                                        {
                                            return (<div key={'sics_' + i}  className='home__body__day' onClick={() => { setCurrentSic(d); setCurrentRace(''); }}>{d}</div>);
                                        })
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        currentsic &&
                        (
                            <>
                                <div className='home__body__subtitle'>{'Races of ' + currentday + " " + currentsic + ':'}</div>
                                <div className='home__body__days'>
                                    {
                                        races.filter(d =>
                                        {
                                            return (d.match(/^([0-9]{8})([A-Z-]{2,3})([0-9]{1,})$/) || ["", "", "", ""])[2] === currentsic;
                                        }
                                        ).map((d, i) =>
                                        {
                                            return (<div key={'races_' + i}  className='home__body__day' onClick={() => { setCurrentRace(d); getRace(d); }}>{d}</div>);
                                        })
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        currentrace &&
                        (
                            <>
                                <div className='home__body__subtitle'>{'stats of ' + currentrace + ':'}</div>
                                <div className='home__body__files'>
                                    {
                                        stats.map((d, i) =>
                                        {
                                            return (
                                                <div className='home__body__contfile' key={'file_' + i}>
                                                    <div className='home__body__file'>{"Horse " +(d.match(/^([0-9]{8})([A-Z-]{2,3})([0-9]{1,})_([0-9]{1,})\.(.+)$/) || ["", "", "", "", "", ""])[4]}</div>
                                                    <div className='home__body__img'>
                                                        <img src={findapiserverurl() +'/api/getimage/' + currentrace + '/' + d + '/' + getToken()} alt={d} onClick={() => { setCurrentStats(currentrace + '/' + d); }}/>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </>
                        )
                    }
                    {
                        currentstats &&
                        (
                            <div className='home__body__fullimg' onClick={() => { setCurrentStats(''); }}>
                                <img src={findapiserverurl() +'/api/getimage/' + currentstats + '/' + getToken()} alt={currentstats} onClick={() => { setCurrentStats(''); }}/>
                            </div>
                        )
                    }
                </div>
            </div>
        </LayoutSite>
    );
}
